module.exports = __webpack_public_path__ + "img/place.f6725cd3.png";